<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    style="z-index: 400000"
  >
    <div class="fixed inset-0 transition-opacity">
      <div
        class="absolute inset-0 bg-gray-500 opacity-75"
        @click="$emit('close')"
      ></div>
    </div>
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 shadow-xl sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="embed-modal-title" 
    >
      <div class="absolute top-0 right-0 pt-4 pr-4">
        <button
          type="button"
          class="rounded-md bg-white text-gray-400 hover:text-gray-500"
          @click="$emit('close')"
        >
          <span class="sr-only">Close</span>
          <svg
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <h3
        id="embed-modal-title"
        class="text-lg leading-6 font-medium text-gray-900"
      >
        Add embed block
      </h3>
      <p class="mt-2 text-sm text-gray-500">
        {{ description }}
      </p>
      <ol class="mt-4 list-decimal list-inside text-sm text-gray-700 space-y-2">
        <li>
          Click <strong>Add embed block</strong> to open the theme editor.
        </li>
        <li>In the left sidebar, open <strong>App embeds</strong>.</li>
        <li>Click <strong>Save</strong> in the theme editor.</li>
      </ol>
      <div class="mt-5 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
          @click="openEmbedLink"
        >
          <span
            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
            >Add embed block</span
          >
        </button>
        <button
          type="button"
          class="mt-3 sm:mt-0 sm:mr-3 Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
          @click="$emit('close')"
        >
          <span
            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
            >Close</span
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmbedBlockModal",
  props: {
    description: {
      type: String,
      required: true
    }
  },
  methods: {
    openEmbedLink() {
      this.$store.dispatch("getEmbedUrl").then((response) => {
        window.open(response.url, "_blank");
      });
    }
  }
};
</script>
